<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :label="$lang.block" v-model="block" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="fancy" :label="$lang.fancy" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" v-for="(badge, index) in badges" :key="index">
        <badge-generator
          :block="block"
          :rounded="rounded"
          :fancy="fancy"
          :title="`${badge.subject} (${badge.status})`"
          :subject-bg-color="badge.subjectBgColor"
          :subject-color="badge.subjectColor"
          :status-bg-color="badge.statusBgColor"
          :status-color="badge.statusColor"
          :icon="icon ? badge.icon : null"
          :subject="badge.subject"
          :status="badge.status" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBadgeGenerator',
  mixins: [
    methods
  ],
  data () {
    return {
      badges: [],
      fancy: false,
      block: false,
      icon: true,
      rounded: true
    }
  },
  mounted () {
    this.setBadges()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/badge-generator.vue